import { COLORS } from "../../shared/constants";
import { IconEdit, IconCopy, IconPlus, IconTrash } from "../../shared/icons";
import { useState } from "react";
import ScaleBuilderForm from "./ScaleBuilderForm";

export default // ─── Assessment Scales Settings Tab ──────────────────────────
function AssessmentScalesTab({ scales, onSave, onCopy, onDelete, currentUser }) {
  const [editing, setEditing] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  if (editing !== null) {
    return <ScaleBuilderForm
      scale={editing === "NEW" ? null : editing}
      onSave={async (data) => { await onSave(data); setEditing(null); }}
      onCancel={() => setEditing(null)}
    />;
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <h3 style={{ fontSize: "16px", fontWeight: "600", color: COLORS.text, margin: 0 }}>Assessment Scales ({scales.length})</h3>
        <button onClick={() => setEditing("NEW")}
          style={{ height: "34px", padding: "0 16px", borderRadius: "8px", border: "none", background: COLORS.primary, color: "#FFF", fontSize: "12px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}>
          <IconPlus /> New Scale
        </button>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            {["Short Name", "Full Name", "Mode", "Questions", "Max", "Remission ≤", "Type", "Active", "Actions"].map(h => (
              <th key={h} style={{ padding: "8px 10px", textAlign: "left", fontSize: "10px", fontWeight: "600", color: COLORS.textSecondary, textTransform: "uppercase", letterSpacing: "0.3px", borderBottom: `2px solid ${COLORS.border}` }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {scales.map(s => (
            <tr key={s.id} style={{ borderBottom: `1px solid ${COLORS.borderLight}`, opacity: s.is_active === false ? 0.45 : 1 }}>
              <td style={{ padding: "10px", fontSize: "13px", fontWeight: "600", color: COLORS.primary }}>{s.short_name}</td>
              <td style={{ padding: "10px", fontSize: "12px", color: COLORS.text }}>{s.name}</td>
              <td style={{ padding: "10px" }}>
                <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "10px", fontWeight: "600",
                  background: s.administration_mode === "CLINICIAN" ? "#FFF3E6" : s.administration_mode === "BOTH" ? "#E8F0FE" : "#E8F8F0",
                  color: s.administration_mode === "CLINICIAN" ? "#D4700A" : s.administration_mode === "BOTH" ? "#1A56DB" : COLORS.accent,
                }}>{s.administration_mode === "SELF_REPORT" ? "Self-Report" : s.administration_mode === "CLINICIAN" ? "Clinician" : "Both"}</span>
              </td>
              <td style={{ padding: "10px", fontSize: "12px", color: COLORS.textSecondary }}>{(s.questions || []).length}</td>
              <td style={{ padding: "10px", fontSize: "12px", color: COLORS.textSecondary }}>{s.max_score}</td>
              <td style={{ padding: "10px", fontSize: "12px", color: COLORS.textSecondary }}>{s.remission_cutoff ?? "—"}</td>
              <td style={{ padding: "10px" }}>
                {s.is_system_default ? (
                  <span style={{ padding: "2px 6px", borderRadius: "4px", fontSize: "9px", fontWeight: "700", background: COLORS.inputBg, color: COLORS.textSecondary, letterSpacing: "0.3px" }}>SYSTEM</span>
                ) : (
                  <span style={{ padding: "2px 6px", borderRadius: "4px", fontSize: "9px", fontWeight: "700", background: COLORS.primaryLight, color: COLORS.primary, letterSpacing: "0.3px" }}>CUSTOM</span>
                )}
              </td>
              <td style={{ padding: "10px" }}>
                <button
                  onClick={async () => {
                    await onSave({ ...s, is_active: !s.is_active, questions: s.questions, severity_bands: s.severity_bands });
                  }}
                  style={{
                    padding: "3px 10px", borderRadius: "10px", fontSize: "10px", fontWeight: "700", border: "none", cursor: "pointer",
                    background: s.is_active !== false ? "#E8F8F0" : "#F0F2F5",
                    color: s.is_active !== false ? COLORS.accent : COLORS.textSecondary,
                  }}>
                  {s.is_active !== false ? "Active" : "Inactive"}
                </button>
              </td>
              <td style={{ padding: "10px" }}>
                <div style={{ display: "flex", gap: "4px" }}>
                  {!s.is_system_default && (
                    <button onClick={() => setEditing(s)}
                      style={{ height: "26px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.primary, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>
                      <IconEdit />
                    </button>
                  )}
                  <button onClick={() => onCopy(s.id)}
                    style={{ height: "26px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.textSecondary, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>
                    <IconCopy />
                  </button>
                  {!s.is_system_default && (
                    confirmDeleteId === s.id ? (
                      <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
                        <span style={{ fontSize: "10px", color: COLORS.danger, fontWeight: "600" }}>Delete?</span>
                        <button onClick={() => { onDelete(s.id); setConfirmDeleteId(null); }}
                          style={{ height: "26px", padding: "0 8px", borderRadius: "6px", border: "none", background: COLORS.danger, color: "#FFF", fontSize: "10px", fontWeight: "600", cursor: "pointer" }}>Yes</button>
                        <button onClick={() => setConfirmDeleteId(null)}
                          style={{ height: "26px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.textSecondary, fontSize: "10px", cursor: "pointer" }}>No</button>
                      </div>
                    ) : (
                      <button onClick={() => setConfirmDeleteId(s.id)}
                        style={{ height: "26px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.dangerBorder}`, background: COLORS.dangerLight, color: COLORS.danger, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>
                        <IconTrash />
                      </button>
                    )
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}


